<!DOCTYPE html>
<html lang="en" xml:lang="en">
  <head>
    <title>Error 404</title>
  </head>
  <body>
    <div>
      <div class="error-container">
        <h1>Oops!404 Not Found</h1>
        <div class="error-message" style="color: #ffffff;
        font-size: 12px;
        padding-bottom: 2em;">
          Sorry, an error has occurred, Requested page not found!
        </div>
        <div>
          <a
            href="/"
            class="btn btn btn-lg"
            style="background-color: #FFD958;
            color: #000;
            font-size: 12px;
            font-weight: 500;
            border-radius: 5px;"
            >Take Me Home</a
          >
          <a href="/" class="btn btn" style="font-size: 12px; color: #fff;">Contact Support</a>
        </div>
      </div>
    </div>
  </body>
</html>
